<template>
<div class="chapter">
<div class="inner_page">
<div class="center">
<p class="ORIM-Dedication--Front-Matter-" lang="en-US">To Suzy, Bob, Colleen, and Bonnie, for all the love and support you have shown me over the years</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MissingHeiress1.vue?5a6af3ba